// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__6a6S8","filesListContainer":"PosDisputesFiles_filesListContainer__3KfH3","filesButton":"PosDisputesFiles_filesButton__1kuhP"};